module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_Chapters"
  }, [_c('span', [_vm._v("First Interlude")])]), _vm._v(" "), _c('p', {
    staticClass: "P_First_Paragraph"
  }, [_vm._v("T"), _c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("he gas station convenience store could have been a twin to the one outside Lake Thunderbird, Oklahoma: snacks, hygiene, dry goods, automotive accessories, and refrigerated items. At that other store, something very bad had recently happened. At this one, something very bad was in the process of happening.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("Jacob Darien held the revolver casually, comfortably, but it was pointed at the clerk all the same. His tone of voice suggested this was old hat for him. “Two strips of beef jerky, five lottery tickets, and all your money. You want anything, Dizzy?”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("The scantily clad redhead draped over his left shoulder picked up at the mention of her pet name. “Umm…bubblegum. Can I get some bubblegum, Jakey-poo?”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("He looked at her and the clerk thought hard about the shotgun under the counter. “Really? My name in front of our guest?”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“You used mine first, my consort,” Dizzy replied, only half chastised.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("”I doubt they have a birth certificate on you.” Jacob’s tone softened, his accent changed. “Go forth and get thy gum, my child.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("She kissed him on the cheek and went prancing off down the candy aisle. “Thank you, Reverend. Jakey was getting a little boring.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("The clerk slowly lowered his hands to the register. “All right, all right, I don’t want any trouble. You can have the money.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("The robber’s face had relaxed, gotten older, the voice more fatherly now. “Bless you, my son. It is the will of the goddess that you doeth thus. Do as thou are told and all will go well with you.” He turned his head to the girl again. “My daughter, I shall require a Dr Pepper to quencheth my thirsteth.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("He turned back just when the clerk had gathered the confidence to go for the gun. “I’m a doctor, too. My degree is in sophistry, young man. An excellent field of study for any man of the cloth, don’t you think?”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("The clerk shoved the money into a plastic sack, unable to think of how he should reply to that. “There you go.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("The robber known as Jakey-poo and Reverend glanced down at the bag. “I believeth my host specifically requested beef jerky and lottery tickets as well. I do not bear false witness in this, do I?”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“Right, right,” the clerk turned to the jerky jar. “I just…I’ve never been robbed before.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("He put two sticks of dried meat on the counter, then reached underneath as if going for the scratch tickets. His right hand wrapped around the stock of the gun when the man spoke again. “Where is the rest of it?”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("The man’s voice had changed again. This time it held neither the casualness of the first nor the joviality of the second. Now he sounded like a cold-hearted British movie villain. The clerk’s nerves froze at his tone.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("Dizzy yelled from the coolers. “Hey, Mr. Osborne, you’re not supposed to be out during a creative acquisition. Jakey-poo said so.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“He’ll thank me later.” The man’s eyes never left the clerk. “This young man was just thinking about trying out his boss’s gun.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("The clerk whipped it out and leveled it at Jacob-Reverend-Osborne. “Maybe I am. Get the fuck out.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“Pull the trigger and you’re a dead man,” the robber growled.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“Ooo,” Dizzy clapped, dropping three bottles of Dr. Pepper on the floor. “A real Wild West showdown.” One of the bottles began spraying brown foam in every direction.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("The voice returned to its initial bored coolness as he tilted his head down to his shoulder. “I’ve got this, Osborne.” When he turned back to the clerk, there was no threat in his voice. “Put it down, Stephen. It’s not your money, it’s the store’s. They’ll never miss it. Insurance will repay them for every dime we take and then some. The only ones getting screwed over here are the insurance companies.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“I’m telling you man, get the fuck out, and take your freaky girlfriend with you. I don’t want to call the cops, but I’m not...”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("He lost his voice when Jacob gestured with his free hand. The clerk had been so fixated on the gun hand, he barely noticed the motion. The shotgun leapt from his hands and sailed across the front toward the magazine rack. The robber never touched it, but it had been torn from his fingers all the same.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("The last thing he remembered before he passed out was the girl, giggling with ecstasy. “Eek, we’re showing off our magic. Yay, Jakey-poo…I mean, stranger I’ve never met before.” As she jumped up and down, the clerk made note not only of her firm breasts, but also of the pair of fiery wings sprouting out of her back and the tiny curved horns appearing on her forehead.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("Jacob hopped the counter, took five tickets off the Lucky 7’s roll, then walked back around, stopping to pick up the shotgun. He cracked it open like a pro. “No ammo.” He tossed the gun toward Dizzy.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("She caught it and moved up to kiss him. “Could come in handy anyway. Maybe goddess is telling us we need more firepower.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“More?” Jacob cocked an eyebrow at her. “Baby, you’re already traveling with the three most powerful wizards on the planet and that’s just what I’m packing in this body. What do you think we’re here to do, start Armageddon?”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("A dark voice answered Jacob from the depths of his subconscious.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia__And__Italic"
  }, [_vm._v("“Pretty much. Shouldn’t be too much longer before we can get the party started.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3647a882","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0010.vue
// module id = 90
// module chunks = 0